import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Divider,
  Modal,
  Popconfirm,
  Row,
  Col,
} from "antd";
import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTrainerSearchText,
//   ChangeStudentTableData,
//   ChangeTrainerModalState,
// } from "../../../actions/adminAction";
import { changeTrainerSearchText } from "../../../reducers/admin";
import { fetchStudentTableData } from "../../../features/adminAsync";
import "./allstudent.css";
import Alert from "../../../components/common/alert";
import { SecureDelete, SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
// import NewTrainerForm from "../newTrainer/newtrainer";
import CrossIcon from "../../../assets/crossIcon.svg";
import {
  DeleteOutlined,
  SearchOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const AllStudent = () => {
  const [isInfo, setIsInfo] = useState(false);
  const [activeStudent, setActiveStudent] = useState(null);
  const searchInput = useRef(null);

  const dispatch = useDispatch();
  const { studentTableData, loading, TrainersearchText } = useSelector(
    (state) => state.admin
  );
  //  console.log("Student",studentTableData);

  useEffect(() => {
    dispatch(fetchStudentTableData());
  }, [dispatch]);

  const handleApproved = async (id) => {
    // console.log("Key",id)
    try {
      const res = await SecurePost({
        url: `${apis.APROVE_STUDENT}`,
        data: {
          studentId: id,
        },
      });

      if (res) {
        dispatch(fetchStudentTableData());
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteStudent = (id) => {
        console.log("Key",id)

    SecureDelete({
      url: `${apis.DELETE_STUDENT}${id}`,
    })
      .then((response) => {
        if (response.data.message) {
          Alert("success", "Success", response.data.message);
          dispatch(fetchStudentTableData());
        } else {
          Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        Alert("error", "Error!", message);
      });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    dispatch(changeTrainerSearchText(selectedKeys[0]));
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    dispatch(changeTrainerSearchText(""));
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[TrainersearchText]}
        autoEscape
        textToHighlight={text?.toString() || ""}
      />
    ),
  });

  const nameColumnSearchProps = getColumnSearchProps("name");
  const emailColumnSearchProps = getColumnSearchProps("emailid");
  const contactColumnSearchProps = getColumnSearchProps("contact");
  const levelColumnSearchProps = getColumnSearchProps("level");
  const tutorColumnSearchProps = getColumnSearchProps("tutorName");

  const columns = [
    {
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      width: "25%",
      ...nameColumnSearchProps,
      render: (text) => {
        const rendered = nameColumnSearchProps.render
          ? nameColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Email Id</span>,
      dataIndex: "emailid",
      key: "emailid",
      width: "25%",
      ...emailColumnSearchProps,
      render: (text) => {
        const rendered = emailColumnSearchProps.render
          ? emailColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Contact Number</span>,
      dataIndex: "contact",
      key: "contact",
      ...contactColumnSearchProps,
      render: (text) => {
        const rendered = contactColumnSearchProps.render
          ? contactColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Level</span>,
      dataIndex: "level",
      key: "level",
      ...levelColumnSearchProps,
      render: (text) => {
        const rendered = levelColumnSearchProps.render
          ? levelColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Tutor Name</span>,
      dataIndex: "tutorName",
      key: "tutorName",
      ...tutorColumnSearchProps,
      render: (text) => {
        const rendered = tutorColumnSearchProps.render
          ? tutorColumnSearchProps.render(text)
          : text;
        return <span style={{ color: "black" }}>{rendered}</span>;
      },
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "_id",
      dataIndex: "_id",
      render: (key, obj) => (
        <span>
          <Button type="primary" onClick={() => handleApproved(key)}>
            {obj.approved ? "Approved" : "Pending"}
          </Button>
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure？"
            cancelText="No"
            okText="Yes"
            onConfirm={() => deleteStudent(key)}
            icon={<DeleteOutlined style={{ color: "red" }} />}
          >
            <Button danger shape="circle" icon={<DeleteOutlined />} />
          </Popconfirm>
          <Divider type="vertical" />
          <Button
            type="primary"
            shape="circle"
            icon={<InfoCircleOutlined />}
            onClick={() => {
              setActiveStudent(obj);
              setIsInfo(true);
            }}
          />
        </span>
      ),
    },
  ];

  return (
    <div className="admin-table-container">
      <div className="register-trainer-form-header">
        <Typography.Title
          level={4}
          style={{ color: "#fff", textAlign: "center" }}
        >
          List of Students
        </Typography.Title>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={studentTableData}
        size="medium"
        pagination={{ pageSize: 10 }}
        loading={loading}
        rowKey="_id"
        style={{ backgroundColor: "#fff", padding: "10px" }}
      />

      {/* <Modal
        visible={TrainermodalOpened}
        title={false}
        onCancel={() =>
          dispatch(changeTrainerModalStates(false, null, "Register"))
        }
        style={{
          top: "20px",
          padding: "0px",
          backgroundColor: "rgb(155,175,190)",
        }}
        width="40%"
        destroyOnClose
        footer={null}
      >
        <NewTrainerForm />
      </Modal> */}

      <Modal
        open={isInfo}
        footer={null}
        closable={false}
        onCancel={() => setIsInfo(false)}
        className="rewardMModalAdmin"
        width={650}
        style={{ top: "30%", borderRadius: "25px", backgroundColor: "#ffff" }}
      >
        <div className="student-info-modal-content">
          <div className="modal-close-btn">
            <img
              style={{ cursor: "pointer" }}
              src={CrossIcon}
              alt="close"
              onClick={() => setIsInfo(false)}
            />
          </div>

          <Typography className="cretaCateText">
            {activeStudent?.name}
          </Typography>

          <Typography>
            Amount of points: {activeStudent?.points} points
          </Typography>

          <Typography>Purchase History</Typography>
          <Row gutter={16}>
            <Col span={6}>
              <Typography className="tableHeadTextInvoice">Name</Typography>
            </Col>
            <Col span={6}>
              <Typography className="tableHeadTextInvoice">
                Invoice No.
              </Typography>
            </Col>
            <Col span={6}>
              <Typography className="tableHeadTextInvoice">Cost</Typography>
            </Col>
            <Col span={6}>
              <Typography className="tableHeadTextInvoice">Status</Typography>
            </Col>
          </Row>

          {activeStudent?.rewardHistory?.length ? (
            activeStudent.rewardHistory.map((item, index) => (
              <Row gutter={16} key={index}>
                <Col span={6}>
                  <Typography
                    className="tableHeadTextInvoice"
                    style={{ fontSize: 12 }}
                  >
                    {item?.rewardId?.name}
                  </Typography>
                </Col>
                <Col span={6}>
                  <Typography
                    className="tableHeadTextInvoice"
                    style={{ fontSize: 12 }}
                  >
                    {item?.invoiceNumber}
                  </Typography>
                </Col>
                <Col span={6}>
                  <Typography
                    className="tableHeadTextInvoice"
                    style={{ fontSize: 12 }}
                  >
                    {item?.rewardId?.cost}
                  </Typography>
                </Col>
                <Col span={6}>
                  <Typography
                    className="tableHeadTextInvoice"
                    style={{ fontSize: 12 }}
                  >
                    {item?.status === "past" ? "Delivered" : "Un Deliver"}
                  </Typography>
                </Col>
              </Row>
            ))
          ) : (
            <Typography>No History Found</Typography>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default AllStudent;
